import {
  BuildTimeControlWidths,
  estimateRibbonScalingStepsSLR,
  getRibbonBottomBarWidthSLR,
  initializeVirtualScalingStateSLR,
  RibbonScalingStateSLRWithCacheKeys,
  scaleRibbonDown,
  setEstimatedScalingWidths,
} from '..';
import { chevronWidth, tabContentContainerPadding } from '../RibbonBottomBar.classNames';

/**
 * Determines the scalingState to be rendered given the buildTimeControlWidths
 */
export function scaleRibbonDownWithBuildTimeScalingSLR(
  scalingState: RibbonScalingStateSLRWithCacheKeys,
  knownWidths: BuildTimeControlWidths,
  reactMLRIsEnabled: boolean,
  onWarning: ((message: string) => void) | undefined
) {
  // Initialize the virtualScalingState and fill it with our known widths
  let draftVirtualScalingState = initializeVirtualScalingStateSLR(scalingState, knownWidths);

  // Determine the width of the ribbon
  const scalingData = getRibbonBottomBarWidthSLR(
    scalingState,
    knownWidths,
    tabContentContainerPadding,
    reactMLRIsEnabled
  );

  // Log errors on controls that we tried to estimate but couldn't
  scalingData.unknownIds.forEach(controlId => {
    onWarning?.(`Trying to estimate unknown width. ControlId: ${controlId}`);
  });

  // Determine the effect of applying each scaling step
  let estimatedWidths = estimateRibbonScalingStepsSLR(scalingState, scalingData.width, draftVirtualScalingState);

  // Set the calculated estimatedWidths so they don't have to be re-computed by the quickScaling logic
  setEstimatedScalingWidths(estimatedWidths);

  let spaceAvailable = window.innerWidth - (reactMLRIsEnabled ? chevronWidth : 0);

  // If the entire ribbon content fits, don't apply any scaling steps
  if (spaceAvailable > scalingData.width) {
    return scalingState;
  }

  // Determine the scaling step that first allows content to fit in the window
  for (let step in estimatedWidths) {
    if ((estimatedWidths[step] as number) < spaceAvailable) {
      return scaleRibbonDown(scalingState, parseInt(step, 10) - scalingState.appliedScalingStepCount);
    }
  }

  return scaleRibbonDown(scalingState, scalingState.scalingSteps.length - scalingState.appliedScalingStepCount);
}
